var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, ".calculator_svg__st4{fill:#fff}.calculator_svg__st5{fill:#260046}");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "calculator_svg__Layer_2"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 40,
  r: 40,
  fill: "none"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "calculator_svg__SVGID_1_",
  d: "M0 0h80v80H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "calculator_svg__SVGID_00000096031923281929463680000008870603318382781841_"
}, /*#__PURE__*/React.createElement("use", {
  overflow: "visible",
  xlinkHref: "#calculator_svg__SVGID_1_"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#calculator_svg__SVGID_00000096031923281929463680000008870603318382781841_)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#eaeaea",
  d: "M40 80c22.093 0 40-17.909 40-40C80 17.907 62.093-.002 40-.002S0 17.907 0 40c0 22.091 17.907 40 40 40"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#calculator_svg__SVGID_00000096031923281929463680000008870603318382781841_)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ea4403",
  d: "M55.287 14.743H23.719c-.682 0-1.24.558-1.24 1.24v48.033c0 .682.558 1.24 1.24 1.24h31.568c.685 0 1.243-.558 1.243-1.24V15.983c0-.682-.558-1.24-1.243-1.24"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#calculator_svg__SVGID_00000096031923281929463680000008870603318382781841_)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.629 19.443h25.813v13.825H26.629z",
  className: "calculator_svg__st4"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#calculator_svg__SVGID_00000096031923281929463680000008870603318382781841_)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.684 37.014h6.005v5.457h-6.005z",
  className: "calculator_svg__st4"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#calculator_svg__SVGID_00000096031923281929463680000008870603318382781841_)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M36.622 37.014h6.005v5.457h-6.005z",
  className: "calculator_svg__st4"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#calculator_svg__SVGID_00000096031923281929463680000008870603318382781841_)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M46.437 37.014h6.005v5.457h-6.005z",
  className: "calculator_svg__st4"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#calculator_svg__SVGID_00000096031923281929463680000008870603318382781841_)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.684 46.147h6.005v5.457h-6.005z",
  className: "calculator_svg__st4"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#calculator_svg__SVGID_00000096031923281929463680000008870603318382781841_)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M36.622 46.147h6.005v5.457h-6.005z",
  className: "calculator_svg__st4"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#calculator_svg__SVGID_00000096031923281929463680000008870603318382781841_)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M46.437 46.147h6.005v5.457h-6.005z",
  className: "calculator_svg__st4"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#calculator_svg__SVGID_00000096031923281929463680000008870603318382781841_)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.657 55.464h6.005v5.457h-6.005z",
  className: "calculator_svg__st4"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#calculator_svg__SVGID_00000096031923281929463680000008870603318382781841_)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M36.596 55.464h6.005v5.457h-6.005z",
  className: "calculator_svg__st4"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#calculator_svg__SVGID_00000096031923281929463680000008870603318382781841_)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M46.41 55.464h6.005v5.457H46.41z",
  className: "calculator_svg__st4"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#calculator_svg__SVGID_00000096031923281929463680000008870603318382781841_)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.619 25.568l-.648.198a.803.803 0 01-.198.027.486.486 0 01-.486-.468c0-.234.144-.414.369-.478l.954-.306c.216-.063.378-.099.541-.099h.018a.54.54 0 01.549.549v5.329a.545.545 0 01-.549.549.551.551 0 01-.549-.549v-4.752zM40.256 29.754l1.936-1.647c.864-.729 1.18-1.134 1.18-1.702 0-.621-.441-.981-1.018-.981-.504 0-.855.234-1.242.703a.508.508 0 01-.387.171.503.503 0 01-.504-.504c0-.117.045-.243.126-.342.513-.639 1.099-1.018 2.089-1.018 1.233 0 2.08.756 2.08 1.882v.018c0 .99-.522 1.53-1.639 2.439l-1.297 1.081h2.557c.271 0 .486.216.486.486s-.216.486-.486.486h-3.574c-.342 0-.594-.198-.594-.522-.001-.217.098-.397.287-.55zM45.764 30.114a.532.532 0 01-.18-.396c0-.288.243-.531.531-.531.162 0 .279.063.369.144.396.396.847.604 1.432.604.621 0 1.089-.378 1.089-.955v-.018c0-.621-.567-.972-1.449-.972h-.225a.48.48 0 01-.478-.477c0-.144.062-.279.234-.45l1.476-1.575h-2.286a.482.482 0 110-.964H49.5c.315 0 .55.189.55.486 0 .261-.126.414-.315.604l-1.485 1.539c.954.117 1.854.604 1.854 1.765v.018c0 1.162-.892 1.999-2.206 1.999-.927-.002-1.621-.326-2.134-.821z",
  className: "calculator_svg__st5"
})));

var SvgCalculator = function SvgCalculator(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalculator, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calculator.30a30625.svg";
export { ForwardRef as ReactComponent };